<script>
    import EditUser from "../data/EditUser";
    import UserValidator from "../data/UserValidator";

    import TextField from "../../../common/text-field.vue";
    import MyuserCard from "../../myuser/components/myuser-card.vue";
    import {translations} from "../data/variables";
    import Checkbox from "../../../content/common/PrimeVue/Checkbox.vue";
    import UserWizardUserTypeField from "../user-wizard-user-type-field.vue";

    export default {
        name: "user-wizard-general",
        components: {UserWizardUserTypeField, Checkbox, MyuserCard, TextField},
        props: {
            user: EditUser,
            validator: UserValidator,
            addMode: Boolean
        },
        computed: {
            translations() {
                return translations
            },
            isSuperAdmin() {
                return Laravel.isUserSuperAdmin;
            }
        },
        mounted() {
            // initial validation
            this.$emit('valid', 'email');
            this.$emit('valid', 'firstName');
            this.$emit('valid', 'lastName');
            if (!this.addMode) {
                this.$emit('valid', 'password');
            }
        }
    }
</script>

<template>
    <div class="d-flex flex-column" style="height: inherit; overflow: scroll">
        <myuser-card
            :user="user"
            :addMode="addMode"
            disableImage
            pwChangeNeedsSuperadmin
            :invalidProperties="validator.getInvalidProperties()"
            @change="(property, value, valid) => $emit('input', property, value, valid)"
        />
        <div v-if="isSuperAdmin" class="d-flex flex-row m-b-sm">
            <div class="d-flex flex-grow-1 pa-2">
                <text-field
                    :value="user.customerName"
                    @input="value => $emit('input','customerName', value)"
                    :label="translations.customerName"
                />
            </div>
            <div class="d-flex flex-grow-1 pa-2">
                <text-field
                    :value="user.customerExternalId"
                    @input="value => $emit('input','customerExternalId', value)"
                    :label="translations.customerExternalId"
                />
            </div>
            <div class="d-flex w-50">
                <v-select-custom
                    :class="addMode ? 'w-50 pa-2' : 'pa-2'"
                    :value="user.getLevelDisplayText()"
                    @input="value => $emit('input','level', value, true)"
                    :items="user.getLevelDisplayTexts()"
                    :label="translations.levels"
                    :disabled="user.isSuperadmin"
                    popup-used-in-modal
                />
                <user-wizard-user-type-field
                    :disabled="!addMode"
                    class="pa-2"
                    :user="user"
                    :validator="validator"
                />
            </div>
        </div>
    </div>
</template>
